import React, { useState, useEffect, useRef } from 'react';
import {
  AlertCircle,
  CalendarIcon,
  Clock,
  MoreVertical,
} from 'lucide-react';
import momentZone from "moment-timezone";
import { LeaveBalance, TeamAvailability, TotalHeadCount } from "../../../../component/icons/user-dashboard";
import InnerLoader from '../../../../component/ui/loader/inner-loader';
import DataNotFound from '../../../../component/ui/loader/data-not-found';
import { Table, TableBody, TableCell, TableHead, TableHeaderWrap, TableRow } from '../../../../component/table/table-layout';
import { useApiCall } from '../../../../component/custom-hooks/api-call';
import OverviewCard from '../../../../component/ui/card/overview';
import StatCard from '../../../../component/ui/card/stat';
import moment from "moment";
import { useNavigate } from 'react-router';
import Style from "./style.module.css"
import Tooltip from '../../../../component/ui/tooltip';
import PlusIcon from '../../../../component/icons/plus';
import { FeildWraper } from '../../../../component/form/form-layout';
import { CustomDropdown } from '../../../../component/ui/dropdown/CustomDropdown';
import { CustomDropdownButton } from '../../../../component/ui/dropdown/CustomDropdownButton';
import { CustomDropdownMenu } from '../../../../component/ui/dropdown/CustomDropdownMenu';
import { CustomDropdownMenuList } from '../../../../component/ui/dropdown/CustomDropdownMenuList';
import RefundList from './list';
import KpisPopup from './kpis-popup';
import RefundForm from '../../refundForm';
import { Alert, Snackbar } from '@mui/material';
import AreaLineChart from '../../../../component/ui/chart/area-line';

// const Card = ({
//     children,
//     heading = "Card Heading",
//     subHeading = null,
//     Icon = null,
//     headerRight = null,
//     moreOff = false,
//     loading = true,
//     condition = true,
//     DataNotFoundText,
//     footer = null,
//     iconColor = null,
//     height = null,
//     className = null,
//     onlyText = false,
// }) => {
//     return (
//         <div
//             className={`
//         bg-white/80 shadow-card rounded-[10px] 
//           border border-[#e1e4ea] 
//           py-7 gap-5 w-full h-full 
//           flex flex-col justify-between
//           [scrollbar-width:none]
//           [&::-webkit-scrollbar]:hidden
//           [&_*::-webkit-scrollbar]:hidden
//           [&_*]:[scrollbar-width:none]
//           ${className}  
//         `}
//         >
//             {/* Main Content */}
//             <div className="flex flex-col gap-5 overflow-hidden w-full h-full">
//                 {/* HEADER */}
//                 <div className="space-y-2.5 pb-2.5 border-b border-[rgba(82,88,102,0.20)] px-7">
//                     <div className="flex items-center justify-between">
//                         <h3 className="text-base font-bold text-[#0E121B] flex items-center gap-[10px] [&[fill]]:fill-current [&[stroke]]:stroke-current">
//                             <div className={`${iconColor ? iconColor : "bg-theme-green-light text-theme-green"} px-2 py-1 rounded-md`}>
//                                 {Icon ? Icon : <TotalHeadCount />}
//                             </div>
//                             {heading}
//                         </h3>
//                         <div className="flex items-center gap-3">
//                             {headerRight ? headerRight : null}
//                             {!moreOff ? <button className="text-[#A4A7AE]"><MoreVertical className="w-5 h-5" /></button> : null}
//                         </div>
//                     </div>
//                     {subHeading ? <p className="text-sm text-[#535862]">{subHeading}</p> : null}
//                 </div>

//                 {/* BODY */}
//                 {loading ? (
//                     <div
//                         className="flex h-full w-full items-center justify-center"
//                         style={{ height: height }}
//                     >
//                         <InnerLoader />
//                     </div>
//                 ) : (
//                     condition ? (
//                         children
//                     ) : (
//                         <div
//                             className="w-full h-full flex items-center justify-center"
//                             style={{ height: height }}
//                         >
//                             <DataNotFound title={DataNotFoundText} onlyText={onlyText} />
//                         </div>
//                     )
//                 )}
//             </div>

//             {/* FOOTER */}
//             {footer ? footer : null}
//         </div>
//     )
// }

const DateTime = () => {
  const [currentTime, setCurrentTime] = useState("");

  const getCurrentTime = () => {
    const fromZone = momentZone.tz.guess();
    const toZone = "Asia/Karachi";
    const newNow = momentZone.tz(new Date(), fromZone);
    const converted = newNow.clone().tz(toZone);
    const formattedTime = converted.format("DD MMM YYYY, hh:mm A");
    setCurrentTime(formattedTime);
  };

  useEffect(() => {
    getCurrentTime();
    const interval = setInterval(getCurrentTime, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-5 p-3 rounded-[10px] border border-[rgba(255,255,255,1)] bg-[rgba(255,255,255,0.60)]">
      <div className="flex flex-col gap-[5px]">
        <p className="text-sm leading-none text-[rgba(14,18,27,0.60)]">
          Current Time
        </p>
        <div className="text-xl leading-none font-bold flex items-center gap-1">{currentTime}</div>
      </div>
      <div>
        <Clock />
      </div>
    </div>
  )
}

// const rowColors = ["#4f7ef8", "#f59e0b", "#22c55e", "#8b5cf6", "#ef4444"]


// function ApprovalRow({ colorIndex = 0, onAction = () => { } }) {
//   return (
//     <div className="flex items-center gap-3 px-[18px] py-[12px] border-b border-[#f3f4f6] hover:bg-[#fafbfc] transition">

//       {/* Avatar */}
//       <div
//         className="w-[34px] h-[34px] rounded-full text-white text-[12px] font-bold flex items-center justify-center shrink-0"
//         style={{ background: rowColors[colorIndex] }}   // --green
//       >
//         TM
//       </div>

//       {/* Info */}
//       <div className="flex-1">
//         <div className="text-[12.5px] font-semibold text-[#1a1f2e]">
//           Leave Application — Tariq Mehmood
//         </div>

//         <div className="text-[11px] text-[#8892a4] mt-[1px]">
//           REQ-2025-0425 · HR Services · 5d annual ·{" "}
//           <span className="text-[#22c55e]">
//             On Track
//           </span>{" "}
//           · 0d waiting
//         </div>
//       </div>

//       {/* Buttons */}
//       <div className="flex gap-[6px]">

//         <button
//           onClick={() => onAction?.("approved")}
//           className="px-[12px] py-[5px] text-[11px] font-bold rounded-[6px]
//                        bg-[#f0fdf4] text-[#22c55e] border border-[#bbf7d0]
//                        transition-all duration-150
//                        hover:bg-[#22c55e] hover:text-white"
//         >
//           ✓ Approve
//         </button>

//         <button
//           onClick={() => onAction?.("rejected")}
//           className="px-[12px] py-[5px] text-[11px] font-bold rounded-[6px]
//                        bg-[#fef2f2] text-[#ef4444] border border-[#fecaca]
//                        transition-all duration-150
//                        hover:bg-[#ef4444] hover:text-white"
//         >
//           ✗ Reject
//         </button>

//       </div>
//     </div>
//   );
// }

// function DepartmentList({ data }) {
//   return (
//     <div className="px-[18px] pb-[8px]">
//       {data.map((item, index) => (
//         <div
//           key={index}
//           className={`flex items-center gap-[10px] py-[10px] ${index !== data.length - 1
//             ? "border-b border-[rgba(0,0,0,0.08)]"
//             : ""
//             }`}
//         >
//           <div
//             className="w-[8px] h-[8px] rounded-full shrink-0"
//             style={{ background: item.color }}
//           />
//           <div className="flex-1 text-[12.5px] font-medium text-[#1a1f2e]">
//             {item.label}
//           </div>
//           <div className="min-w-[28px] text-right text-[13px] font-bold text-[#1a1f2e]">
//             {item.value}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

// function MetricRow({ metrics }) {
//   return (
//     <div className="flex border-t border-[#e8eaed]">
//       {metrics.map((item, index) => (
//         <div
//           key={index}
//           className={`flex-1 px-[18px] py-[12px] text-center ${index !== metrics.length - 1
//             ? "border-r border-[#e8eaed]"
//             : ""
//             }`}
//         >
//           <div className="text-[10.5px] text-[#8892a4] font-semibold uppercase tracking-[0.3px]">
//             {item.label}
//           </div>
//           <div
//             className="text-[18px] font-extrabold mt-[2px]"
//             style={{ color: item.color }}
//           >
//             {item.value}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// }

export default function MyDashboard() {
  const apiCall = useApiCall();

  const [overviewData, setOverviewData] = useState({});
  const [isLoading, setIsLoading] = useState(true)

  const getData = async () => {
    try {
      const apiRes = await apiCall({ method: "get", url: "get-my-esm-overview" })
      setOverviewData(apiRes?.data);
      setIsLoading(false)
      // console.log("ApiRes", apiRes)
    } catch (error) {
      console.log("Err", error)
    }
  }

  useEffect(() => {
    getData();
  }, [])

  const data = [
    { label: "Pending Approval", value: 3 || 0, color: "#16a34a" },
    { label: "In Progress", value: 4 || 0, color: "#d97706" },
    { label: "Overdue", value: 1 || 0, color: "#dc2626" },
    // apiData?.attendance_breakdown?.half_day && { label: "Half Day", value: apiData?.attendance_breakdown?.half_day || 0, color: "#7c3aed" },
    // apiData?.attendance_breakdown?.leaves && { label: "On Leave", value: apiData?.attendance_breakdown?.leaves || 0, color: "#0095FF" },
  ].filter(Boolean);

  const total = data.reduce((acc, item) => acc + item.value, 0);

  const radius = 50;
  const circumference = 2 * Math.PI * radius;

  let cumulativePercent = 0;

  const metrics = [
    { label: "SLA Met", value: "87.5%", color: "#22c55e" },
    { label: "Avg Age", value: "2.1d", color: "#4f7ef8" },
    { label: "Priority High", value: "2", color: "#ef4444" },
  ];

  const badgeColor = {
    "gray": "bg-[#f3f4f6] text-[#8892a4]",
    "yellow": "bg-[#fffbeb] text-[#b45309]",
    "green": "bg-[#f0fdf4] text-[#22c55e]",
    "blue": "bg-[#eef2ff] text-[#4f7ef8]",
    "red": "bg-[#fef2f2] text-[#ef4444]",
  }

  const alertColors = {
    "info": "text-[#1d4ed8] bg-[#eef2ff] border border-[#bfdbfe]",
    "warn": "text-[#92400e] bg-[#fffbeb] border border-[#fde68a]",
    "danger": "text-[#991b1b] bg-[#fef2f2] border border-[#fecaca]",
    "success": "text-[#f0fdf4] bg-[#eef2ff] border border-[#bbf7d0]"
  }

  /////////// OLD CODE //////////////////

  const [dashboardData, setDashboardData] = useState({});
  const [isDashboardApiLoaded, setIsDashboardApiLoaded] = useState(false);
  const [isTrendLoad, setIsTrendLoad] = useState(false);
  const [monthlyTrend, setMonthlyTrend] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(
    moment(new Date()).format("YYYY-MM")
  );
  const [activeChart, setActiveChart] = useState("Refunded Amount");
  const [allTime, setAllTime] = useState(false);
  const [allTimeLoader, setAllTimeLoader] = useState(false);
  const [kpiData, setKpiData] = useState({});
  const [apiData, setApiData] = useState({});
  const [sourceData, setSourceData] = useState([]);


  const [trendAllTime, setTrendAllTime] = useState(false);


  const [showRefund, setShowRefund] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [showWorkForce, setShowWorkForce] = useState(false);
  const [popupData, setPopupData] = useState({});

  const [selMonth, setSelMonth] = useState({});

  const [filterType, setFilterType] = useState("month");
  // month | all_time | range

  const [rangeType, setRangeType] = useState(null);
  // last_month | this_year | last_year | this_quater

  const [stEnDates, setStEnDates] = useState({});

  const getDashboardData = async () => {
    setIsDashboardApiLoaded(false);

    try {
      let params = "";

      if (filterType === "all_time") {
        params = "all_time=1";
      } else if (filterType === "month") {
        params = `year_month=${selectedMonth}`;
      } else if (filterType === "range" && rangeType) {
        params = `range=${rangeType}`;
      }

      const resp = await apiCall({
        method: "get",
        url: `reports/dashboard?${params}`,
      });

      console.log("Source ", resp?.data?.types_data);

      setDashboardData(resp);
      setKpiData(resp?.data);
      setSelMonth(resp?.month);
      setApiData(resp?.data?.qa_status_report);
      setIsDashboardApiLoaded(true);
      setSourceData(resp?.data?.types_data);
      setStEnDates({
        start_date: resp?.start_date,
        end_date: resp?.end_date,
      });
    } catch (error) {
      console.warn(error);
    }
  };

  const route = useNavigate();

  console.log(activeChart);
  //   try {
  //     const resp = await apiCall({ method: "get", url: `get-monthly-water-tanker-trends?type=chart` });
  //     setMonthlyTrend(resp.data);
  //     setIsTrendLoad(true);
  //   } catch (error) {
  //     console.log("Err", error)
  //   }
  // }

  // useEffect(() => {
  //   getMonthlyTrend();
  // }, []);

  useEffect(() => {
    getDashboardData();
  }, [filterType, rangeType, selectedMonth]);

  const parseAmount = (value = "PKR 0.00") =>
    Number(value.replace("PKR ", "").replaceAll(",", ""));

  const rawData = monthlyTrend; // API response

  const dynamicKeys = Object.keys(rawData?.[0] || {}).filter(
    (key) => key !== "month"
  );

  // LINE CHART
  const [trendData, setTrendData] = useState([]);
  const [trendLoading, setTrendLoading] = useState(false);

  const [selectedMonths, setSelectedMonths] = useState(12);
  const [months, setMonths] = useState([]);
  const [fullMonthlyData, setFullMonthlyData] = useState([]);

  const getTrendData = async () => {
    setTrendLoading(true);
    try {
      // Decide API call only for "all" or first monthly load
      const shouldCallAPI =
        selectedMonths === "all" || fullMonthlyData.length === 0;

      let resData;

      if (shouldCallAPI) {
        const url =
          selectedMonths === "all"
            ? "reports/yearly-trends"
            : "reports/monthly-trends";

        const res = await apiCall({ method: "get", url });
        resData = res.data;

        if (selectedMonths !== "all") {
          // cache monthly data
          setFullMonthlyData(resData);
        }
      } else {
        // use cached monthly data
        resData = fullMonthlyData;
      }

      if (selectedMonths === "all") {
        // Yearly data
        const firstYear = Object.keys(resData)[0];
        const monthsArray = resData[firstYear].map(d => d.month);
        setMonths(monthsArray);

        const series = Object.keys(resData)
          .sort((a, b) => b - a) // newest year first
          .map(year => ({
            name: year,
            data: resData[year].map(d =>
              Number(d.total_loss_amount.replaceAll("$", "").replaceAll(",", ""))
            ),
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, "rgba(59,130,246,0.25)"],
                [1, "rgba(59,130,246,0.02)"],
              ],
            },
          }));
        setTrendData(series);
      } else {
        // Monthly data (slice locally)
        const filteredData =
          selectedMonths === "all"
            ? resData
            : resData.slice(-selectedMonths);

        setMonths(filteredData.map(d => d.month));
        setTrendData([
          {
            name: "Loss Revenue",
            data: filteredData.map(d =>
              Number(d.total_loss_amount.replaceAll("$", "").replaceAll(",", ""))
            ),
            fillColor: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, "rgba(59,130,246,0.25)"],
                [1, "rgba(59,130,246,0.02)"],
              ],
            },
          },
        ]);
      }
    } catch (error) {
      console.warn("Error fetching trend data:", error);
    } finally {
      setTrendLoading(false);
    }
  };

  // console.log("trendData", trendData)


  const lineOptions = {
    chart: { type: "line", backgroundColor: "transparent", height: 300 },
    title: { text: "" },
    xAxis: {
      categories: months, // use months state
      lineColor: "#E5E7EB",
      labels: { style: { color: "#6B7280" } },
    },
    yAxis: {
      title: { text: "Loss Revenue" },
      gridLineColor: "#F3F4F6",
      labels: { style: { color: "#6B7280" } },
    },
    legend: {
      enabled: true,
      align: "right",        // horizontal alignment
      verticalAlign: "top",  // vertical alignment
      // layout: "vertical",    // stack series vertically
    },
    series: trendData,
    credits: { enabled: false },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        return this.points
          .map(p => `<span style="color:${p.color}">${p.series.name}: ${p.y}</span>`)
          .join("<br/>");
      },
    },
  };



  useEffect(() => {
    getTrendData();
    // getLeadsBySourceData()
  }, [selectedMonths]);

  // DONUT CHART - Leads by Source
  const USE_DUMMY_DATA = true;
  const [sourceLoading, setSourceLoading] = useState(false);

  // const getLeadsBySourceData = async () => {
  //   setSourceLoading(false);
  //   try {
  //     if (USE_DUMMY_DATA) {
  //       const dummy = [
  //         { source: "Total Lost", count: 20 },
  //         { source: "Total Refund", count: 15 },
  //         { source: "Charge Back", count: 10 },
  //         { source: "Sales Blame", count: 9 },
  //         // { source: "Customer Blame", count: 9 },
  //       ];
  //       setSourceData(dummy);
  //     } else {
  //       const res = await apiCall({ method: "get", url: "leads/dashboard/by-source" });
  //       setSourceData(res?.sources);
  //     }
  //   } catch (error) {
  //     console.warn("Error fetching leads by source:", error);
  //   } finally {
  //     setSourceLoading(true);
  //   }
  // };

  const sourceOptions = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 320,
      spacing: [20, 0, 20, 0],
    },
    title: null,
    credits: { enabled: false },
    tooltip: {
      pointFormat: "<b>${point.y}</b> <br/>({point.percentage:.1f}%)",
    },
    plotOptions: {
      pie: {
        innerSize: "65%",
        borderWidth: 2,
        borderColor: "#fff",
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          distance: 15,
          style: { color: "#374151", fontSize: "12px" },
          format: "{point.name}: {point.percentage:.1f}%",
          filter: { property: "percentage", operator: ">", value: 2 },
        },
        showInLegend: true,
      },
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemStyle: { color: "#6B7280", fontSize: "12px" },
    },
    series: [
      {
        name: "Refund",
        colorByPoint: false, // disable auto colors
        data: sourceData?.map((el) => ({
          name: el?.type,
          y: el?.amount,
          color: (() => {
            switch (el?.type) {
              case "Refund":
                return "#3b5998";
              case "Refund Against Duplicate":
                return "#f4b400";
              case "Chargeback":
                return "#34a853";
              case "Chargeback Alert":
                return "#6c757d";
              case "Chargeback RDR":
                return "#ff5722";
              default:
                return "#888888";
            }

          })(),
        })),
      },
    ],
    events: {
      render() {
        const chart = this;
        const total = chart.series[0].data.reduce((acc, p) => acc + p.y, 0);
        const labelX = chart.plotWidth / 2 + chart.plotLeft - 25;
        const labelY = chart.plotHeight / 2 + chart.plotTop - 25;

        if (!chart.customLabel) {
          chart.customLabel = chart.renderer
            .label(`Total<br><b>${total}</b>`, labelX, labelY)
            .css({ textAlign: "center", color: "#111827", fontSize: "13px" })
            .add();
        } else {
          chart.customLabel.attr({ text: `Total<br><b>${total}</b>` });
        }
      },
    },
  };

  const changeAllTime = (e) => {
    setAllTime(e);
  };

  const inputRef = useRef();

  const openMonthPicker = () => {
    if (inputRef.current?.showPicker) {
      inputRef.current.showPicker();
    } else {
      inputRef.current?.focus();
      inputRef.current?.click();
    }
  };

  const getFilterLabel = () => {
    if (filterType === "all_time") return "All Time";

    if (filterType === "range") {
      const map = {
        last_month: "Last Month",
        this_year: "This Year",
        last_year: "Last Year",
        this_quater: "This Quarter",
      };
      return map[rangeType] || "Select";
    }

    // month
    return moment(selectedMonth, "YYYY-MM").format("MMMM YYYY");
  };

  const hasKpiData =
    Number(kpiData?.cb_won) > 0 ||
    Number(kpiData?.cb_win_rate) > 0 ||
    Number(kpiData?.cb_lost) > 0;

  const handleKpiClick = (type) => {
    const filters = {};

    // Backend always gives start_date & end_date for current selection
    if (stEnDates?.start_date && stEnDates?.end_date) {
      filters.date_range = `${stEnDates.start_date},${stEnDates.end_date}`;
    }

    // Build query manually to keep comma
    let query = `type=${type}`;
    if (filters.date_range) query += `&date_range=${filters.date_range}`;

    // route(`/refunds/organization/refund?${query}`);

    window.open(`/refunds/organization/refund?${query}`, '_blank')

  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    // setSelectedIds([]);
    // getData({});
    // setChangeModal(false);
    setShowRefund(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const chartColors = [
    "#3b82f6",
    "#ec4899",
    "#cbd5e1"
  ]

  const totalAmount = sourceData?.reduce((sum, item) => sum + item.amount, 0);

  const chartData = {
    categories: months,
    data: trendData
    // data: [
    //   {
    //     name: "Total Deals",
    //     color: "#3B82F6",
    //     data:
    //       overAllData?.last_12_months_by_status_won_loss?.map(
    //         (d) => d?.total_deal
    //       ),

    //     fillColor: {
    //       linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
    //       stops: [
    //         [0, "rgba(59,130,246,0.25)"],
    //         [1, "rgba(59,130,246,0.02)"],
    //       ],
    //     },
    //   },

    //   {
    //     name: "Won Deals",
    //     color: "#10B981",
    //     data:
    //       overAllData?.last_12_months_by_status_won_loss?.map(
    //         (d) => d?.won_deal
    //       ),

    //     fillColor: {
    //       linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
    //       stops: [
    //         [0, "rgba(16,185,129,0.25)"],
    //         [1, "rgba(16,185,129,0.02)"],
    //       ],
    //     },
    //   },

    //   {
    //     name: "Lost Deals",
    //     color: "#EF4444",
    //     data:
    //       overAllData?.last_12_months_by_status_won_loss?.map(
    //         (d) => d?.lost_deal
    //       ),

    //     fillColor: {
    //       linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
    //       stops: [
    //         [0, "rgba(239,68,68,0.25)"],
    //         [1, "rgba(239,68,68,0.02)"],
    //       ],
    //     },
    //   },
    // ],
  };

  return (
    <div className="w-full h-full overflow-hidden overflow-y-auto flex flex-col gap-[20px] !pt-[20px] !p-5">
      {/* Page Header */}
      <div className="flex items-center justify-between w-full">
        <div className="flex flex-col">
          <div className="text-2xl font-bold  flex items-center gap-1">Refunds Overviews</div>
          <p className="text-sm  text-[rgba(14,18,27,0.60)]">Refunds Overviews</p>
        </div>

        <div className="flex gap-3 flex-shrink-0 w-fit items-center justify-end">
          <div className={Style.bpfl_action}>
            {/* <div
              className={Style.bpfl_action}
              onClick={() => {
                setShowRefund(true);
              }}
            >
              <Tooltip
                content={"Add Refund"}
                position={"left center"}
                className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
              >
                <div className={Style.icon}>
                  <PlusIcon size="1em" />
                </div>
              </Tooltip>
            </div> */}
            <FeildWraper className={"!w-fit !flex-[0_0_auto] !pl-0 !py-0"}>
              <div className="relative">
                <input
                  type="month"
                  ref={inputRef}
                  className="absolute opacity-0 pointer-events-none"
                  max={moment(new Date()).format("YYYY-MM")}
                  value={selectedMonth}
                  onChange={(e) => {
                    setFilterType("month");
                    setRangeType(null);
                    setSelectedMonth(e.target.value);
                  }}
                />

                <CustomDropdown
                  position="bottom-right"
                  className="myDropdown"
                >
                  <CustomDropdownButton arrow={false} className="btnClass">
                    <div className="flex items-center gap-2 px-5 py-1">
                      <CalendarIcon size={16} />
                      <h3 className="!text-[16px]">{getFilterLabel()}</h3>
                    </div>
                  </CustomDropdownButton>

                  <CustomDropdownMenu className="w-full">
                    <CustomDropdownMenuList
                      className={
                        filterType === "all_time" ? "bg-[#f2f2f2]" : ""
                      }
                      onClick={() => {
                        setFilterType("all_time");
                        setRangeType(null);
                      }}
                    >
                      All Time
                    </CustomDropdownMenuList>

                    <CustomDropdownMenuList
                      className={
                        rangeType === "last_month" ? "bg-[#f2f2f2]" : ""
                      }
                      onClick={() => {
                        setFilterType("range");
                        setRangeType("last_month");
                      }}
                    >
                      Last Month
                    </CustomDropdownMenuList>

                    <CustomDropdownMenuList
                      onClick={() => {
                        setFilterType("range");
                        setRangeType("this_year");
                      }}
                    >
                      This Year
                    </CustomDropdownMenuList>

                    <CustomDropdownMenuList
                      onClick={() => {
                        setFilterType("range");
                        setRangeType("last_year");
                      }}
                    >
                      Last Year
                    </CustomDropdownMenuList>

                    <CustomDropdownMenuList
                      onClick={() => {
                        setFilterType("range");
                        setRangeType("this_quater");
                      }}
                    >
                      This Quarter
                    </CustomDropdownMenuList>

                    <CustomDropdownMenuList
                      onClick={() => {
                        setFilterType("month");
                        setRangeType(null);
                        openMonthPicker();
                      }}
                    >
                      Custom Month
                    </CustomDropdownMenuList>
                  </CustomDropdownMenu>
                </CustomDropdown>
              </div>
            </FeildWraper>

            <div className={`
              bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
              hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)]
              
              py-[10px] px-[12px] rounded-[5px] text-center 
              text-[#fff] text-[12px] font-semibold text-nowrap 
              flex items-center justify-center transition-all
              gap-1
              cursor-pointer
            `}
              onClick={() => {
                setShowRefund(true);
              }}
            >
              <PlusIcon />
              Add Refund
            </div>
          </div>
        </div>
      </div>
      {/* mx-[24px] */}
      {/* <div className={`flex items-center gap-[10px] px-[16px] py-[10px] rounded-[8px] mb-[14px] text-[12.5px] font-medium ${alertColors["info"]}`}>
        <span>ℹ️</span>
        <div><strong className='font-bold'>Development Team Overview</strong> — {overviewData?.notification?.message}</div>
        <span className="ml-auto text-[16px] cursor-pointer opacity-50">×</span>
      </div> */}

      <div className="grid grid-cols-12 gap-5">
        <div className="col-span-12">
          <div className="grid grid-cols-4 gap-5">
            {/* <div className=''>
              <OverviewCard
                Icon={<TotalHeadCount />}
                iconColor={'bg-theme-purple-light text-theme-purple'}
                heading={"Total Lost"}
                // subHeading={overviewData?.createdByMe?.cards?.created_this_month?.month_name}
                DataNotFoundText={`Tickets`}
                footer={null}
                loading={!isDashboardApiLoaded}
                onlyText={true}
                moreOff
              >
                <div className="flex items-center justify-between py-0 px-7 w-full h-full">
                  <div className="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="42" viewBox="0 0 70 53" fill="none">
                      <foreignObject x="-18" y="12.0863" width="80.6074" height="58.652"><div xmlns="http://www.w3.org/1999/xhtml" style={{
                        backdropFilter: "blur(9px)",
                        clipPath: "url(#bgblur_0_7621_11124_clip_path)",
                        height: "100%",
                        width: "100%"
                      }}></div></foreignObject><path data-figma-bg-blur-radius="18" d="M22.3066 30.8617C32.7868 30.8619 41.5444 38.2304 43.6855 48.0668L43.7793 48.5472C44.1215 50.3077 42.7336 51.9632 40.9062 51.9633H3.70117C1.87376 51.9632 0.485937 50.3077 0.828125 48.5472C2.78479 38.4714 11.6565 30.8617 22.3066 30.8617Z" fill="url(#paint0_linear_7621_11124)" stroke="black" strokeWidth="1.55" />
                      <foreignObject x="-6.94531" y="-15.7207" width="58.4902" height="58.49"><div xmlns="http://www.w3.org/1999/xhtml" style={{
                        backdropFilter: "blur(9px)",
                        clipPath: "url(#bgblur_0_7621_11124_clip_path)",
                        height: "100%",
                        width: "100%"
                      }}></div></foreignObject><path data-figma-bg-blur-radius="18" d="M19.8951 3.33718C25.5214 2.00924 31.1592 5.49324 32.4872 11.1195C33.8152 16.746 30.3303 22.384 24.7039 23.7119C19.0776 25.0398 13.4404 21.5548 12.1125 15.9284C10.7847 10.3021 14.2689 4.6652 19.8951 3.33718Z" fill="url(#paint1_linear_7621_11124)" stroke="black" strokeWidth="1.55" />
                      <path d="M51.3398 35.4467C59.6206 35.4467 66.5392 41.2602 68.2354 49.0287L68.3125 49.4242C68.5663 50.7309 67.5372 51.9633 66.1748 51.9633H36.5C35.1427 51.9632 34.1093 50.7257 34.3623 49.4252L34.3633 49.4242C35.9074 41.4585 42.9194 35.4469 51.3398 35.4467Z" fill="url(#paint2_linear_7621_11124)" stroke="white" strokeWidth="1.55" />
                      <path d="M51.3389 13.2595C55.8653 13.2595 59.535 16.9284 59.5352 21.4548C59.5352 25.9813 55.8654 29.6511 51.3389 29.6511C46.8125 29.6509 43.1436 25.9812 43.1436 21.4548C43.1437 16.9285 46.8126 13.2596 51.3389 13.2595Z" fill="url(#paint3_linear_7621_11124)" stroke="white" strokeWidth="1.55" />
                      <defs>
                        <clipPath id="bgblur_0_7621_11124_clip_path" transform="translate(18 -12.0863)"><path d="M22.3066 30.8617C32.7868 30.8619 41.5444 38.2304 43.6855 48.0668L43.7793 48.5472C44.1215 50.3077 42.7336 51.9632 40.9062 51.9633H3.70117C1.87376 51.9632 0.485937 50.3077 0.828125 48.5472C2.78479 38.4714 11.6565 30.8617 22.3066 30.8617Z" />
                        </clipPath><clipPath id="bgblur_1_7621_11124_clip_path" transform="translate(6.94531 15.7207)"><path d="M19.8951 3.33718C25.5214 2.00924 31.1592 5.49324 32.4872 11.1195C33.8152 16.746 30.3303 22.384 24.7039 23.7119C19.0776 25.0398 13.4404 21.5548 12.1125 15.9284C10.7847 10.3021 14.2689 4.6652 19.8951 3.33718Z" />
                        </clipPath><linearGradient id="paint0_linear_7621_11124" x1="2.51834" y1="51.4595" x2="18.7427" y2="19.5097" gradientUnits="userSpaceOnUse">
                          <stop stopColor="white" stop-opacity="0.2" />
                          <stop offset="1" stopColor="white" stop-opacity="0.49" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_7621_11124" x1="14.8842" y1="25.5216" x2="29.7152" y2="1.52709" gradientUnits="userSpaceOnUse">
                          <stop stopColor="white" stop-opacity="0.2" />
                          <stop offset="1" stopColor="white" stop-opacity="0.49" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_7621_11124" x1="51.3403" y1="62.6808" x2="51.3403" y2="8.35878" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#F6005A" />
                          <stop offset="1" stopColor="#F7CBAD" />
                        </linearGradient>
                        <linearGradient id="paint3_linear_7621_11124" x1="51.3391" y1="-223.148" x2="51.3391" y2="8.35887" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#F6005A" />
                          <stop offset="1" stopColor="#F7CBAD" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>

                  <div className="text-[48px] text-[#0e121b] font-bold leading-[1]">
                    <h6>{kpiData?.total_loss_amount}</h6>
                  </div>
                </div>
              </OverviewCard>
            </div> */}

            <div className=''>
              <StatCard
                svg={
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 12.75C17.8023 12.75 18.25 13.1977 18.25 13.75V16.25H20.75C21.3023 16.25 21.75 16.6977 21.75 17.25C21.75 17.8023 21.3023 18.25 20.75 18.25H18.25V20.75C18.25 21.3023 17.8023 21.75 17.25 21.75C16.6977 21.75 16.25 21.3023 16.25 20.75V18.25H13.75C13.1977 18.25 12.75 17.8023 12.75 17.25C12.75 16.6977 13.1977 16.25 13.75 16.25H16.25V13.75C16.25 13.1977 16.6977 12.75 17.25 12.75Z" fill="currentColor"></path><path opacity="0.4" d="M15 20.75H3C2.58579 20.75 2.25 20.4142 2.25 20C2.25 16.3234 4.81022 13.2447 8.2451 12.4495C6.20857 11.7274 4.75 9.78405 4.75 7.5C4.75 4.60051 7.1005 2.25 10 2.25C12.8995 2.25 15.25 4.60051 15.25 7.5C15.25 9.78405 13.7914 11.7274 11.7549 12.4495C12.9712 12.7311 14.0779 13.299 15 14.0784V15H13.75C12.5074 15 11.5 16.0074 11.5 17.25C11.5 18.4926 12.5074 19.5 13.75 19.5H15V20.75Z" fill="currentColor"></path></svg>
                }
                className='h-full'
                iconBgColor="#FEE2E2"
                iconColor="#FF4040"
                title={"Total Loss"}
                unit=""
                trend={null}
                value={kpiData?.total_loss_amount}
                target={0}
                trendLabel=""
                color="rgb(239, 68, 68)"
                variant=""
                statsBadge={`Overall revenue lost this period`}
                // statusText={"Overall revenue lost this period"}
                isAlert={false}
                // positive={true}
                // stateLable={`${((Number(kpiData?.total_refunded_amount?.replaceAll("$", "")) / Number(kpiData?.total_loss_amount?.replaceAll("$", ""))) * 100).toFixed(2)}%` }
                isAlertColor={'risk'}
                onClick={() => handleKpiClick("all-refunds")}
              />
            </div>

            <div className=''>
              <StatCard
                svg={
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.25 12.75C17.8023 12.75 18.25 13.1977 18.25 13.75V16.25H20.75C21.3023 16.25 21.75 16.6977 21.75 17.25C21.75 17.8023 21.3023 18.25 20.75 18.25H18.25V20.75C18.25 21.3023 17.8023 21.75 17.25 21.75C16.6977 21.75 16.25 21.3023 16.25 20.75V18.25H13.75C13.1977 18.25 12.75 17.8023 12.75 17.25C12.75 16.6977 13.1977 16.25 13.75 16.25H16.25V13.75C16.25 13.1977 16.6977 12.75 17.25 12.75Z" fill="currentColor"></path><path opacity="0.4" d="M15 20.75H3C2.58579 20.75 2.25 20.4142 2.25 20C2.25 16.3234 4.81022 13.2447 8.2451 12.4495C6.20857 11.7274 4.75 9.78405 4.75 7.5C4.75 4.60051 7.1005 2.25 10 2.25C12.8995 2.25 15.25 4.60051 15.25 7.5C15.25 9.78405 13.7914 11.7274 11.7549 12.4495C12.9712 12.7311 14.0779 13.299 15 14.0784V15H13.75C12.5074 15 11.5 16.0074 11.5 17.25C11.5 18.4926 12.5074 19.5 13.75 19.5H15V20.75Z" fill="currentColor"></path></svg>
                }
                className='h-full'
                iconBgColor="#FEE2E2"
                iconColor="#FF4040"
                title={"Total Refunds"}
                unit=""
                trend={null}
                value={kpiData?.total_refunded_amount}
                target={0}
                trendLabel=""
                color="rgb(239, 68, 68)"
                variant=""
                statsBadge={`Refunded payments processed so far`}
                statusText={""}
                isAlert={false}
                positive={true}
                stateLable={`${((Number(kpiData?.total_refunded_amount?.replaceAll("$", "")) / Number(kpiData?.total_loss_amount?.replaceAll("$", ""))) * 100).toFixed(2)}%` }
                isBadgeColorSame={true}
                isAlertColor={'risk'}
                onClick={() => handleKpiClick("all-refunds")}
              />
            </div>

            <div className=''>
              <StatCard
                svg={
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none"><path opacity="0.4" d="M22.25 12.0526V12V11.9474C22.25 9.75475 22.25 8.03277 22.0693 6.68848C21.8842 5.31182 21.4969 4.21953 20.6387 3.36133C19.7805 2.50313 18.6882 2.11575 17.3115 1.93066C15.9672 1.74998 14.2452 1.74999 12.0526 1.75H12H11.9474C9.75476 1.74999 8.03277 1.74998 6.68848 1.93066C5.31182 2.11575 4.21953 2.50313 3.36133 3.36133C2.50313 4.21953 2.11575 5.31182 1.93066 6.68848C1.74998 8.03277 1.74999 9.75476 1.75 11.9474V12V12.0526C1.74999 14.2452 1.74998 15.9672 1.93066 17.3115C2.11575 18.6882 2.50313 19.7805 3.36133 20.6387C4.21953 21.4969 5.31182 21.8842 6.68848 22.0693C8.03277 22.25 9.75475 22.25 11.9474 22.25H12H12.0526C14.2452 22.25 15.9672 22.25 17.3115 22.0693C18.6882 21.8842 19.7805 21.4969 20.6387 20.6387C21.4969 19.7805 21.8842 18.6882 22.0693 17.3115C22.25 15.9672 22.25 14.2452 22.25 12.0526Z" fill="currentColor"></path><path d="M11 11.5V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V11.5C13 10.9477 12.5523 10.5 12 10.5C11.4477 10.5 11 10.9477 11 11.5Z" fill="currentColor"></path><path d="M11 7.99805V8.00781C11 8.5601 11.4477 9.00781 12 9.00781C12.5523 9.00781 13 8.5601 13 8.00781V7.99805C13 7.44576 12.5523 6.99805 12 6.99805C11.4477 6.99805 11 7.44576 11 7.99805Z" fill="currentColor"></path></svg>
                }
                className='h-full'
                iconBgColor="#fef3c7"
                iconColor="#d97706"
                title={"Total Chargebacks"}
                unit=""
                trend={null}
                value={kpiData?.total_chargeback_amount}
                target={0}
                trendLabel=""
                color="rgb(245, 158, 11)"
                variant=""
                statsBadge={`Disputed payments via chargebacks`}
                statusText={""}
                isAlert={false}
                isAlertColor={'warring'}
                onClick={() => handleKpiClick("all-chargebacks")}
                positive={true}
                isBadgeColorSame={true}
                stateLable={`${((Number(kpiData?.total_chargeback_amount?.replaceAll("$", "")) / Number(kpiData?.total_loss_amount?.replaceAll("$", ""))) * 100).toFixed(2)}%` }
              />
            </div>

            {/* <div className=''>
              <StatCard
                svg={
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8.09996 1.25C8.63844 1.25 9.07496 1.68754 9.07496 2.22727V3.21284C9.65285 3.20453 10.2784 3.20453 10.9537 3.20454H13.0463C13.7216 3.20453 14.3471 3.20453 14.925 3.21284V2.22727C14.925 1.68754 15.3615 1.25 15.9 1.25C16.4385 1.25 16.875 1.68754 16.875 2.22727V3.29947C17.0513 3.31556 17.221 3.33437 17.3843 3.35638C18.5544 3.51407 19.5397 3.85141 20.3221 4.63573C21.1046 5.42004 21.4412 6.40758 21.5985 7.58045C21.6826 8.20706 21.72 8.92803 21.7366 9.75H2.26331C2.27997 8.92803 2.31739 8.20705 2.40144 7.58045C2.55876 6.40758 2.89532 5.42004 3.67782 4.63573C4.46031 3.85141 5.44554 3.51407 6.61568 3.35638C6.77898 3.33437 6.9487 3.31556 7.12496 3.29947V2.22727C7.12496 1.68754 7.56148 1.25 8.09996 1.25Z" fill="currentColor" />
                    <g opacity="0.4">
                      <path d="M10.9537 22.75C9.17581 22.75 7.74279 22.75 6.61573 22.5982C5.44559 22.4405 4.46035 22.1031 3.67786 21.3188C2.89537 20.5345 2.5588 19.547 2.40148 18.3741C2.24996 17.2444 2.24998 15.8081 2.25 14.0261V11.9285C2.24999 11.135 2.24998 10.4099 2.26335 9.75H4.21386C4.20045 10.3958 4.20001 11.1378 4.20001 12V13.9545C4.20001 15.8249 4.20208 17.1294 4.3341 18.1137C4.46235 19.0698 4.69693 19.5761 5.05673 19.9367C5.41652 20.2974 5.92166 20.5325 6.87557 20.6611C7.85752 20.7934 9.15897 20.7955 11.025 20.7955H11.9977C12.5375 20.7955 12.975 21.233 12.975 21.7727C12.975 22.3125 12.5375 22.75 11.9977 22.75H10.9537Z" fill="currentColor" />
                      <path d="M19.8001 13.9796V12C19.8001 11.1378 19.7997 10.3958 19.7863 9.75H21.7368C21.7501 10.4099 21.7501 11.1349 21.7501 11.9285V13.9796C21.7501 14.518 21.3136 14.9545 20.7751 14.9545C20.2366 14.9545 19.8001 14.518 19.8001 13.9796Z" fill="currentColor" />
                    </g>
                    <path d="M20.75 17.25C21.3023 17.25 21.75 17.6977 21.75 18.25C21.75 18.8023 21.3023 19.25 20.75 19.25H13.75C13.1977 19.25 12.75 18.8023 12.75 18.25C12.75 17.6977 13.1977 17.25 13.75 17.25H20.75Z" fill="currentColor" />
                  </svg>
                }
                iconBgColor="#E0F2FE"
                iconColor="#0095FF"
                title={"Sales Blame"}
                unit=""
                trend={null}
                // value={28}
                value={kpiData?.sales_blame_amount}
                target={kpiData?.sales_blame_count}
                trendLabel=""
                color="rgb(59, 130, 246)"
                variant=""
                // statsBadge="Next 30 days"
                // statusText="Peak: Mar 5 (8 leaves)"
                // statsBadge={overviewData?.createdByMe?.cards?.avg_res_esm?.status}
                statusText={"Internal sales errors"}
                isAlert={true}
                isAlertColor={'ok'}
              />
            </div> */}

            <div className=''>
              <StatCard
                svg={
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none"><path opacity="0.4" d="M22.25 12.0526V12V11.9474C22.25 9.75475 22.25 8.03277 22.0693 6.68848C21.8842 5.31182 21.4969 4.21953 20.6387 3.36133C19.7805 2.50313 18.6882 2.11575 17.3115 1.93066C15.9672 1.74998 14.2452 1.74999 12.0526 1.75H12H11.9474C9.75476 1.74999 8.03277 1.74998 6.68848 1.93066C5.31182 2.11575 4.21953 2.50313 3.36133 3.36133C2.50313 4.21953 2.11575 5.31182 1.93066 6.68848C1.74998 8.03277 1.74999 9.75476 1.75 11.9474V12V12.0526C1.74999 14.2452 1.74998 15.9672 1.93066 17.3115C2.11575 18.6882 2.50313 19.7805 3.36133 20.6387C4.21953 21.4969 5.31182 21.8842 6.68848 22.0693C8.03277 22.25 9.75475 22.25 11.9474 22.25H12H12.0526C14.2452 22.25 15.9672 22.25 17.3115 22.0693C18.6882 21.8842 19.7805 21.4969 20.6387 20.6387C21.4969 19.7805 21.8842 18.6882 22.0693 17.3115C22.25 15.9672 22.25 14.2452 22.25 12.0526Z" fill="currentColor"></path><path d="M11 11.5V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V11.5C13 10.9477 12.5523 10.5 12 10.5C11.4477 10.5 11 10.9477 11 11.5Z" fill="currentColor"></path><path d="M11 7.99805V8.00781C11 8.5601 11.4477 9.00781 12 9.00781C12.5523 9.00781 13 8.5601 13 8.00781V7.99805C13 7.44576 12.5523 6.99805 12 6.99805C11.4477 6.99805 11 7.44576 11 7.99805Z" fill="currentColor"></path></svg>
                }
                iconBgColor="#E0F2FE"
                iconColor="#0095FF"
                title={"Customer Blame"}
                unit=""
                trend={null}
                value={kpiData?.customer_blame_amount}
                target={0}
                trendLabel=""
                color="rgb(59, 130, 246)"
                variant=""
                statsBadge={`Customer responsibility in disputes`}
                statusText={"Customer-driven disputes"}
                isAlert={true}
                isAlertColor={'ok'}
              />
            </div>
          </div>
        </div>

        <OverviewCard
          className={'col-span-8'}
          Icon={<TeamAvailability />}
          iconColor={'bg-theme-green-light text-theme-green'}
          heading="Loss Revenue"
          subHeading={"Monthly trend of lost revenue"}
          DataNotFoundText={`Monthly Leave Trend`}
          footer={null}
          loading={!isDashboardApiLoaded}
          condition={true}
          moreOff
          height={'550px'}
        >
          <div className="flex flex-col w-full h-[550px] overflow-y-auto px-5">
            {/* <RefundList data={apiData} isHeading={false} isLoading={isDashboardApiLoaded} /> */}
            <AreaLineChart chartData={chartData} height={550} />
          </div>
        </OverviewCard>

        <OverviewCard
          className={'col-span-4'}
          Icon={<LeaveBalance />}
          iconColor={'bg-theme-pink-light text-theme-pink'}
          heading="Refund by Type"
          subHeading={"Dispute types by refund category"}
          DataNotFoundText={`Refund by Type`}
          footer={null}
          loading={!isDashboardApiLoaded}
          condition={true}
          moreOff
          height={'340px'}
        >
          <div className="flex flex-col gap-5 justify-between items-start w-full h-full px-7">
            <div className="flex items-center justify-center w-full relative">
              <svg width="250" height="250" viewBox="0 0 200 200">
                {/* {(() => {
                  const total = genderData.male + genderData.female + genderData.notFilled;
                  const malePercent = genderData.male / total;
                  const femalePercent = genderData.female / total;
                  const notFilledPercent = genderData.notFilled / total;

                  const radius = 70;
                  const innerRadius = 50;

                  // Male arc
                  const maleAngle = malePercent * 360;
                  const maleEndX = 100 + radius * Math.cos(((maleAngle - 90) * Math.PI) / 180);
                  const maleEndY = 100 + radius * Math.sin(((maleAngle - 90) * Math.PI) / 180);
                  const maleInnerEndX = 100 + innerRadius * Math.cos(((maleAngle - 90) * Math.PI) / 180);
                  const maleInnerEndY = 100 + innerRadius * Math.sin(((maleAngle - 90) * Math.PI) / 180);

                  // Female arc
                  const femaleStartAngle = maleAngle;
                  const femaleAngle = femaleStartAngle + (femalePercent * 360);
                  const femaleStartX = maleEndX;
                  const femaleStartY = maleEndY;
                  const femaleEndX = 100 + radius * Math.cos(((femaleAngle - 90) * Math.PI) / 180);
                  const femaleEndY = 100 + radius * Math.sin(((femaleAngle - 90) * Math.PI) / 180);
                  const femaleInnerStartX = maleInnerEndX;
                  const femaleInnerStartY = maleInnerEndY;
                  const femaleInnerEndX = 100 + innerRadius * Math.cos(((femaleAngle - 90) * Math.PI) / 180);
                  const femaleInnerEndY = 100 + innerRadius * Math.sin(((femaleAngle - 90) * Math.PI) / 180);

                  // Not filled arc
                  const notFilledStartX = femaleEndX;
                  const notFilledStartY = femaleEndY;
                  const notFilledInnerStartX = femaleInnerEndX;
                  const notFilledInnerStartY = femaleInnerEndY;

                  return (
                    <>
                      <path
                        d={`
                          M 100 ${100 - radius}
                          A ${radius} ${radius} 0 ${malePercent > 0.5 ? 1 : 0} 1 ${maleEndX} ${maleEndY}
                          L ${maleInnerEndX} ${maleInnerEndY}
                          A ${innerRadius} ${innerRadius} 0 ${malePercent > 0.5 ? 1 : 0} 0 100 ${100 - innerRadius}
                          Z
                        `}
                        fill="#3b82f6"
                      />
                      <path
                        d={`
                          M ${femaleStartX} ${femaleStartY}
                          A ${radius} ${radius} 0 ${femalePercent > 0.5 ? 1 : 0} 1 ${femaleEndX} ${femaleEndY}
                          L ${femaleInnerEndX} ${femaleInnerEndY}
                          A ${innerRadius} ${innerRadius} 0 ${femalePercent > 0.5 ? 1 : 0} 0 ${femaleInnerStartX} ${femaleInnerStartY}
                          Z
                        `}
                        fill="#ec4899"
                      />
                      <path
                        d={`
                          M ${notFilledStartX} ${notFilledStartY}
                          A ${radius} ${radius} 0 ${notFilledPercent > 0.5 ? 1 : 0} 1 100 ${100 - radius}
                          L 100 ${100 - innerRadius}
                          A ${innerRadius} ${innerRadius} 0 ${notFilledPercent > 0.5 ? 1 : 0} 0 ${notFilledInnerStartX} ${notFilledInnerStartY}
                          Z
                        `}
                        fill="#cbd5e1"
                      />
                    </>
                  );
                })()} */}

                {(() => {
                  const radius = 70;
                  const innerRadius = 50;
                  const center = 100;

                  const total = sourceData?.reduce((sum, item) => sum + item.amount, 0);

                  let startAngle = 0;

                  return sourceData.map((item, index) => {
                    const percent = item.amount / total;
                    const angle = percent * 360;

                    const endAngle = startAngle + angle;

                    const startOuterX = center + radius * Math.cos(((startAngle - 90) * Math.PI) / 180);
                    const startOuterY = center + radius * Math.sin(((startAngle - 90) * Math.PI) / 180);

                    const endOuterX = center + radius * Math.cos(((endAngle - 90) * Math.PI) / 180);
                    const endOuterY = center + radius * Math.sin(((endAngle - 90) * Math.PI) / 180);

                    const startInnerX = center + innerRadius * Math.cos(((startAngle - 90) * Math.PI) / 180);
                    const startInnerY = center + innerRadius * Math.sin(((startAngle - 90) * Math.PI) / 180);

                    const endInnerX = center + innerRadius * Math.cos(((endAngle - 90) * Math.PI) / 180);
                    const endInnerY = center + innerRadius * Math.sin(((endAngle - 90) * Math.PI) / 180);

                    const largeArc = percent > 0.5 ? 1 : 0;

                    const path = `
                      M ${startOuterX} ${startOuterY}
                      A ${radius} ${radius} 0 ${largeArc} 1 ${endOuterX} ${endOuterY}
                      L ${endInnerX} ${endInnerY}
                      A ${innerRadius} ${innerRadius} 0 ${largeArc} 0 ${startInnerX} ${startInnerY}
                      Z
                    `;

                    startAngle = endAngle;

                    return <path key={index} d={path} fill={chartColors[index]} />;
                  });
                })()}

                {/* <text x="100" y="95" textAnchor="middle" style={{
                  fontSize: 10, fontWeight: 600, fill: "#94a3b8",
                }}>
                  Not Filled: {genderData.notFilled}
                </text>
                <text x="100" y="105" textAnchor="middle" style={{
                  fontSize: 10, fontWeight: 600, fill: "#94a3b8",
                }}>
                  Female: {genderData.female}
                </text>
                <text x="100" y="115" textAnchor="middle" style={{
                  fontSize: 10, fontWeight: 600, fill: "#94a3b8",
                }}>
                  Male: {genderData.male}
                </text> */}
                {/* {sourceData?.map((eachData, i) => (
                  <text key={i} x="100" y={95 + i * 10} textAnchor="middle" style={{
                    fontSize: 10, fontWeight: 600, fill: "#94a3b8",
                  }}>
                    {eachData?.type}: ${eachData?.amount}
                  </text>
                ))} */}
              </svg>
            </div>

            {/* Legend */}
            <div className="flex flex-col gap-2.5 w-full">
              {sourceData?.map((eachData, i) => ({ label: eachData?.type, count: eachData?.amount, color: chartColors[i], percent: ((eachData?.amount / totalAmount) * 100).toFixed(1) })).map((item) => (
                <div key={item.label} className="flex items-center justify-between p-2.5 bg-slate-100 rounded-lg">
                  <div className="flex items-center gap-2.5">
                    <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: item.color }} />
                    <span className="text-xs font-semibold text-slate-600">{item.label}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-slate-900">${item.count}</span>
                    <span className="text-[11px] text-slate-400 font-semibold">{item.percent}%</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </OverviewCard>

        <OverviewCard
          className={'col-span-12'}
          Icon={<TeamAvailability />}
          iconColor={'bg-theme-green-light text-theme-green'}
          heading="Refund QA Status"
          subHeading={"Refund requests categorized by QA review status"}
          DataNotFoundText={`Monthly Leave Trend`}
          footer={null}
          loading={!isDashboardApiLoaded}
          condition={true}
          moreOff
          height={'350px'}
        // headerRight={<div className="flex items-center gap-3">
        //     {[
        //         { label: "Approved", color: "#22c55e" },
        //         { label: "Rejected", color: "#ef4444" },
        //         { label: "Pending", color: "#f59e0b" },
        //     ].map(item => (
        //         <div key={item.label} className="flex items-center gap-1.5">
        //             <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: item.color }} />
        //             <span className="text-[11px] font-semibold text-[#64748b]">{item.label}</span>
        //         </div>
        //     ))}
        // </div>}
        >
          <div className="flex flex-col w-full h-[350px] overflow-y-auto px-5">
            {/* <Table>
              <TableHead>
                <TableRow>
                  <TableCell header>
                    Request ID
                  </TableCell>

                  <TableCell header>
                    Service
                  </TableCell>

                  <TableCell header>
                    Category
                  </TableCell>

                  <TableCell header>
                    Priority
                  </TableCell>

                  <TableCell header>
                    Status
                  </TableCell>

                  <TableCell header>
                    SLA
                  </TableCell>

                  <TableCell header>
                    Date
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {overviewData?.createdByMe?.myRecentRequests?.map((eachReq, i) => (
                  <TableRow key={i}>
                    <TableCell className={"!text-[#4f7ef8] !py-[12px]"}>
                      {eachReq?.ticket_id}
                    </TableCell>

                    <TableCell className={"!py-[12px]"}>
                      {eachReq?.service}
                    </TableCell>

                    <TableCell className={"!py-[12px]"}>
                      {eachReq?.category}
                    </TableCell>

                    <TableCell className={"!py-[12px]"}>
                      <span
                        className={`
                          inline-flex items-center gap-[4px]
                          px-[12px] py-[5px] rounded-[20px]
                          text-[12px] font-semibold
                          ${badgeColor["gray"]}
                          before:content-[''] before:w-[6px] before:h-[6px]
                          before:rounded-full before:bg-current
                        `}
                      >
                        {eachReq?.priority}
                      </span>
                    </TableCell>

                    <TableCell className={"!py-[12px]"}>
                      <span
                        className={`
                          inline-flex items-center gap-[4px]
                          px-[12px] py-[5px] rounded-[20px]
                          text-[12px] font-semibold
                          ${badgeColor[(eachReq?.status?.toLowerCase() == "open" || eachReq?.status?.toLowerCase() == "hold") ? "yellow" : (eachReq?.status?.toLowerCase() == "overdue" || eachReq?.status?.toLowerCase() == "escalate") ? "red" : (eachReq?.status?.toLowerCase() == "closed" || eachReq?.status?.toLowerCase() == "complete") ? "green" : "blue"]}
                          before:content-[''] before:w-[6px] before:h-[6px]
                          before:rounded-full before:bg-current
                        `}
                      >
                        {eachReq?.status}
                      </span>
                    </TableCell>

                    <TableCell className={"!py-[12px]"}>
                      <span
                        className={`
                          inline-flex items-center gap-[4px]
                          px-[12px] py-[5px] rounded-[20px]
                          text-[12px] font-semibold
                          ${badgeColor["green"]}
                          before:content-[''] before:w-[6px] before:h-[6px]
                          before:rounded-full before:bg-current
                        `}
                      >
                        On Track
                      </span>
                    </TableCell>

                    <TableCell isDim={true} className={"!py-[12px]"}>
                      {eachReq?.date}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table> */}
            <RefundList data={apiData} isHeading={false} isLoading={isDashboardApiLoaded} />
          </div>
        </OverviewCard>
      </div>
      {showWorkForce && (
        <KpisPopup
          onClose={() => setShowWorkForce(false)}
          apiKey={popupData?.apiKey}
          apiUrl={popupData?.apiUrl}
          pagUrl={popupData?.pagUrl}
          title={popupData?.title}
          subTitle={popupData?.subTitle}
          icon={popupData?.icon}
          positive={popupData?.positive}
          stateLable={popupData?.stateLable}
          positiveIcon={popupData?.positiveIcon}
        />
      )}

      {showRefund && (
        <RefundForm
          onError={onError}
          onSubmit={onSuccess}
          onClose={() => {
            setShowRefund(false);
            // setCurrentData({});
          }}
        // refundDataId={currentData}
        // brands={brands}
        // agents={agents}
        // brandsProducts={brandsProducts}
        // merchants={merchants}
        // merchantsType={merchantsType}
        // cbOrRefundOptions={cbOrRefundOptions}
        // cbOutcomeOptions={cbOutcomeOptions}
        // departmentOptions={departmentOptions}
        // qaStatusOptions={qaStatusOptions}
        // quarterOptions={quarterOptions}
        // repitchOutcomeOptions={repitchOutcomeOptions}
        // responsibleOptions={responsibleOptions}
        // sourceOptions={sourceOptions}
        // workStatusOptions={workStatusOptions}
        // yearOptions={yearOptions}
        // processorReasonOptions={processorReasonOptions}
        />
      )}
      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
